import React, { useEffect, useState, useMemo, useRef } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faFileArrowDown, faPrint, faFilePdf, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import '../css/Style.css';
import { exportTsdTablesToExcelSingleSheet } from "../utils/exportToExcelTsd";
import { exportTsdTablesToPdf } from '../utils/exportToPdfTsd'; 
import api from "../services/api";


const Tsd = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [lineMakers, setLineMakers] = useState([]);
  const [tsdHeader, setTsdHeader] = useState([]);
  const [makers, setMakers] = useState([]);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoading(true);

    api.get(`getTSD`)
    .then(res => {
      const makers = res.data.line_makers || [];
      const months = res.data.headers || [];
        setLineMakers(makers);
        setTsdHeader(months)  
    })
    .catch(err => {
      console.error('GET /getTSD failed:', err);
    })
    .finally(() => {
      setIsLoading(false); // after complete
    });
  }, []);

//Line_Numbers length for table length
  const uniqueLineNumbers = useMemo(() => {
    const numbers = lineMakers
      .map(item => item.line_number)
      .filter(num => num); // Excludes 0, null, undefined, ''

    const unique = [...new Set(numbers)];
    return unique;
  }, [lineMakers]);


//Line leaders for each lines
  const lineLeadersMap = useMemo(() => {
    const map = {};
    lineMakers.forEach(item => {
      if (item.is_line_leader === 'Y' && item.line_number) {
        map[item.line_number] = item.name;
      }
    });
    return map;
    }, [lineMakers]);

    //Assistant leader
    const assistantLineLeadsMap = useMemo(() => {
    const map = {};
    lineMakers.forEach(item => {
      if (item.is_asst === 'Y' && item.line_number) {
      const mapz =  map[item.line_number] = {
          name: item.name,
          data: item.data || {},
        };
      }
    });
    return map;
  }, [lineMakers]);



  //Sample Makers
  const nonLeadAssistByLine = useMemo(() => {
    const result = {};

    lineMakers.forEach(item => {
      const { line_number, name, data, company, is_line_leader, is_asst } = item;

      if (
        String(is_line_leader).trim().toUpperCase() === 'N' &&
        String(is_asst).trim().toUpperCase() === 'N' &&
        line_number
      ) {
        if (!result[line_number]) {
          result[line_number] = [];
        }

        result[line_number].push({ name, company , data});
      }
    });

    return result;
  }, [lineMakers]);

  const getExportData = () => {
  return uniqueLineNumbers.map((lineNumber) => {
    const assistant = assistantLineLeadsMap[lineNumber];
    const makersForLine = nonLeadAssistByLine[lineNumber] || [];

    const subHeaders = Object.entries(tsdHeader).map(([month, ranges]) => ({
      name: month,
      displayName: month.toUpperCase(),
      ranges: Object.keys(ranges)
    }));

    const assistantRow = [
      assistant?.name || "N/A",
      "Sample Maker Asst. Leader",
    ];
    subHeaders.forEach(({ name, ranges }) => {
      let monthTotal = 0;
      ranges.forEach(range => {
        const val = assistant?.data?.[name]?.[range] ?? 0;
        assistantRow.push(val);
        monthTotal += Number(val);
      });
      assistantRow.push(monthTotal);
    });
    // assistantRow.push("", "", "", "", "", "", "");

    const makerRows = makersForLine.map(maker => {
      const row = [maker.name, `Sample Maker (${maker.company})`];
      subHeaders.forEach(({ name, ranges }) => {
        let monthTotal = 0;
        ranges.forEach(range => {
          const val = maker?.data?.[name]?.[range] ?? 0;
          row.push(val);
          monthTotal += Number(val);
        });
        row.push(monthTotal);
      });
      // row.push("", "", "", "", "", "", "");
      return row;
    });

    const weeklyTotalRow = ["TOTAL WEEKLY OUTPUT", ""];
    subHeaders.forEach(({ name, ranges }) => {
      let rangeSums = [];
      ranges.forEach(range => {
        const asst = Number(assistant?.data?.[name]?.[range] ?? 0);
        const makerSum = makersForLine.reduce((sum, maker) => {
          return sum + Number(maker?.data?.[name]?.[range] ?? 0);
        }, 0);
        const total = asst + makerSum;
        weeklyTotalRow.push(total);
        rangeSums.push(total);
      });

      const monthTotal = rangeSums.reduce((a, b) => a + b, 0);
      weeklyTotalRow.push(monthTotal);
    });
    // weeklyTotalRow.push("", "", "", "", "", "", "");

    const monthlyTotalRow = ["", ""];
    subHeaders.forEach(({ name, ranges }) => {
      const asstMonth = Object.values(assistant?.data?.[name] || {}).reduce((sum, v) => sum + Number(v), 0);
      const makerMonth = makersForLine.reduce((sum, maker) => {
        return sum + Object.values(maker?.data?.[name] || {}).reduce((s, v) => s + Number(v), 0);
      }, 0);
      const total = asstMonth + makerMonth;
      monthlyTotalRow.push(`TOTAL: ${total}`);
      for (let i = 0; i < ranges.length; i++) monthlyTotalRow.push("");
    });
    // monthlyTotalRow.push("", "", "", "", "", "", "");

    return {
      sheetName: lineNumber,
      headers: { lineLeader: lineLeadersMap[lineNumber] },
      subHeaders,
      rows: [assistantRow, ...makerRows],
      weeklyTotalRow,
      monthlyTotalRow
    };
  });
};

const handleExcelExport = () => {
  const data = getExportData();
  exportTsdTablesToExcelSingleSheet(data);
};

const handlePdfExport = () => {
  const data = getExportData();
  exportTsdTablesToPdf(data);
};


 return (
    <div className="tsd-main-conainer">
      {isLoading && 
        <div
          className="loading-message"
          style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}
        >
          <div style={{ textAlign: "center" }}>
            <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "30px", color: "blue" }} />
            <h5>Fetching data...</h5>
          </div>
        </div>
      }

      {!isLoading && (
        <>
          <div className="export_btns_tsd">
            <div className="export_icon" >
            

              <div className="export_btn_tsd" >
                <button className="btn btn-success" onClick={handleExcelExport} style={{marginRight:"10px"}}>
                  <FontAwesomeIcon icon={faFileExcel}/> Export to Excel
                </button>
                <button className="btn btn-danger" onClick={handlePdfExport}>
                  <FontAwesomeIcon icon={faFilePdf}/> Export to PDF
                </button>
              </div>
              <FontAwesomeIcon icon={faPrint} className="icon_tsd_export"/>
            </div>
          </div>

          {uniqueLineNumbers.map((line, index) => (
              <Tsd_Table
                lineNumber={line}
                lineLeader={lineLeadersMap[line]}
                assistantLineLeader={assistantLineLeadsMap[line]}
                makers={nonLeadAssistByLine[line]}
                tsdHeader={tsdHeader}
              />
          ))}

        </>
      )}

    </div>
  );

};



const Tsd_Table = ({ tsdHeader, lineNumber , lineLeader, assistantLineLeader, makers = []})=> {
  const [monthTotals, setMonthTotals] = useState({});
  const [weeklyTotals, setWeeklyTotals] = useState({});

  useEffect(() => {
    const newMonthlyTotals = {};
    const newWeeklyTotals = {};

    Object.entries(tsdHeader).forEach(([month, dateObj]) => {
      let monthSum = 0;
      newWeeklyTotals[month] = {};

      Object.keys(dateObj).forEach((range) => {
        let rangeSum = 0;

        const asstVal = parseFloat(assistantLineLeader?.data?.[month]?.[range]);
        if (!isNaN(asstVal)) rangeSum += asstVal;

        (makers || []).forEach((maker) => {
          const val = parseFloat(maker?.data?.[month]?.[range]);
          if (!isNaN(val)) rangeSum += val;
        });

        newWeeklyTotals[month][range] = rangeSum;
        monthSum += rangeSum;
      });

      newMonthlyTotals[month] = monthSum;
    });

    setWeeklyTotals(newWeeklyTotals);
    setMonthTotals(newMonthlyTotals);
  }, [makers, tsdHeader, assistantLineLeader]);

  const totalMonthlyColSpan = Object.values(tsdHeader).reduce((sum, dateObj) => {
    const colSpan = Object.values(dateObj).reduce((innerSum, val) => {
      return Array.isArray(val) ? innerSum + val.length : innerSum;
    }, 0);
    return colSpan > 0 ? sum + colSpan + 1 : sum; // +1 for each month's "TOTAL"
  }, 0);

  const tsdMonths = Object.keys(tsdHeader);
  const firstMonth = tsdMonths[0];
  const lastMonth = tsdMonths[tsdMonths.length - 1];

  return (
    <div className="table-tsd">
     <div className="tsd-scroll-wrapper">
        <table className={`tsd_table-table table_${lineNumber}  table-bordered table-sm`} style={{ minWidth: "100%" }} >
          <thead>
            <tr>
              <th className="col-md-2 text-center p-2 sticky-left col-1" rowSpan="4">NAME</th>
              <th className="text-center p-2 sticky-left col-2" rowSpan="4">Job Position</th>
              <th className="text-center p-2" colSpan={totalMonthlyColSpan}>MONTHLY PRODUCTIVITY REPORT</th>
              <th className="text-center p-2" rowSpan="4">TOTAL WORKING DAYS ({firstMonth} TO {lastMonth})</th>
              <th className="text-center p-2" rowSpan="4">AVERAGE GOAL (PCS)</th>
              <th className="text-center p-2" rowSpan="4">TOTAL OUTPUT ({firstMonth} TO {lastMonth})</th>
              <th className="text-center p-2" rowSpan="4">EFFICIENCY</th>
              <th className="text-center p-2" rowSpan="4">Productivity Rating %</th>
              <th className="text-center p-2" rowSpan="4">Quality  Rating %</th>
              <th className="text-center p-2" rowSpan="4">FINAL RATING %</th>
            </tr>

            {/*months th*/}
            <tr>
             {Object.entries(tsdHeader).map(([month, dateObj], index) => {
              const colSpan = Object.values(dateObj).reduce((sum, val) => {
                return Array.isArray(val) ? sum + val.length : sum;
              }, 0);

              if (colSpan === 0) return null;

              return (
                <th
                  key={index}
                  className={`text-center py-2 month-${month.toLowerCase()}`}
                  colSpan={colSpan + 1}
                >
                  {month.toUpperCase()}
                </th>
              );
            })}
            </tr>

            {/*range th*/}
          
          <tr>
          {Object.entries(tsdHeader).map(([month, dateObj], index) => {
              const days = Object.keys(dateObj);
              return (
                <React.Fragment key={index}>
                  {
                    days.map((dayRange) => {
                      const [start, end] = dayRange.split(" to ");
                      return (
                        <th key={`${month}-${dayRange}`} className={`text-center py-2 month-${month.toLowerCase()}`} id="range_header"><small>
                          {start}<br />to<br />{end}
                        </small></th>
                      );
                    })
                  }
                  <th key={`${month}-total`} className={`text-center py-2 month-${month.toLowerCase()}`}>TOTAL</th>
                </React.Fragment>
              );
            })
          }

          </tr>
          </thead>
          <tbody>

          {/*<!-- Team header row -->*/}
          <tr >
            <td className="team-header sticky-left col-1" colSpan="2">LINE {lineNumber} - {lineLeader || 'N/A'} (LINE LEADER)</td>
            {Object.entries(tsdHeader).map(([month, dateObj], index) => {
              const days = Object.keys(dateObj);
              return (
                <React.Fragment key={index}>
                  {days.map((day) => (
                    <td className={`text-center py-2 month-${month.toLowerCase()}`}>
                      
                    </td>
                  ))}
                  <td className={`text-center py-2 per_maker_total month-${month.toLowerCase()}`}></td>
                </React.Fragment>
              );
            })}
            {(() => {
              const extraTds = [];
              for (let i = 0; i < 7; i++) {
                extraTds.push(<td key={`extra-${i}`}></td>);
              }
              return extraTds;
            })()}
            
          </tr>

          {/*<!-- Assistant Line Lead -->*/}
          <tr>
            <td className="sticky-left col-1">{assistantLineLeader?.name || 'N/A'}</td>
            <td className="job-position sticky-left col-2">Sample Maker Asst. Leader</td>
            {Object.entries(tsdHeader).map(([month, dateObj], mIdx) => {
              let monthTotal = 0;

              const monthCells = Object.keys(dateObj).map((range, rIdx) => {
                const rawVal = assistantLineLeader?.data?.[month]?.[range];
                const value = rawVal ?? '';
                const numericVal = parseFloat(value);
                if (!isNaN(numericVal)) monthTotal += numericVal;

                return (
                  <td key={`asst-${mIdx}-${rIdx}`} className={`makers month-${month.toLowerCase()}`} range-id={range}>
                    {value !== '' ? value : '0'}
                  </td>
                );
              });

              monthCells.push(
                <td key={`asst-${mIdx}-total`} className={`fw-bold text-center per_maker_total ${month} month-${month.toLowerCase()}`}>
                  {monthTotal}
                </td>
              );

              return monthCells;
            })}
            {(() => {
              const extraTds = [];
              for (let i = 0; i < 7; i++) {
                extraTds.push(<td key={`extra-${i}`}></td>);
              }
              return extraTds;
            })()}
          </tr>

          {/*<!-- Makers only -->*/}
         {(makers || []).map((maker, index) => (
            <tr key={index}>
              <td className="sticky-left col-1">{maker.name}</td>
              <td className="job-position sticky-left col-2">
                Sample Maker <small>({maker.company || 'N/A'})</small>
              </td>

              {/* Loop over months */}
              {Object.entries(tsdHeader).map(([month, dateObj], mIdx) => {
                let monthTotal = 0;

                const monthCells = Object.keys(dateObj).map((range, rIdx) => {
                  const rawVal = maker?.data?.[month]?.[range];
                  const value = rawVal ?? '';
                  const numericVal = parseFloat(value);
                  if (!isNaN(numericVal)) monthTotal += numericVal;

                  return (
                    <td key={`${index}-${mIdx}-${rIdx}`} className={`makers month-${month.toLowerCase()}`} range-id={range}>
                      {value !== '' ? value : '0'}
                    </td>
                  );
                });

                // Append total cell for this month
                monthCells.push(
                  <td key={`${index}-${mIdx}-total`} className={`fw-bold text-center per_maker_total ${month} month-${month.toLowerCase()}`}>
                    {monthTotal}
                  </td>
                );

                return monthCells;
              })}

              {/* Extra optional cells */}
              {Array.from({ length: 7 }).map((_, i) => (
                <td key={`extra-${index}-${i}`}></td>
              ))}
            </tr>
          ))}


        {/*<!-- Weekly total... -->*/}
        <tr className="highlight-total">
          <td colSpan="2" className="sticky-left col-1">TOTAL WEEKLY OUTPUT</td>

          {Object.entries(tsdHeader).flatMap(([month, dateObj]) => {
            const rangeCells = Object.keys(dateObj).map((range) => {
              
              return (
                <td key={`${lineNumber}-${month}-${range}`} className="fw-bold text-center">
                  {weeklyTotals?.[month]?.[range] ?? 0}
                </td>
              );
            });

            const totalCell = (
              <td key={`${lineNumber}-${month}-total`} className="fw-bold text-center bg-light monthly-total">
                {monthTotals[month] ?? 0}
              </td>
            );


            return [...rangeCells, totalCell];
          })}

          {Array.from({ length: 7 }).map((_, i) => (
            <td key={`${lineNumber}-extra-${i}`}></td>
          ))}
        </tr>

          {/*<!-- OVERALL TOTAL PER MONTH... -->*/}
          <tr className="final-total">
            <td colSpan="2" className="sticky-left col-1"></td>

            {Object.entries(tsdHeader).map(([month, dateObj], index) => {
              const colSpan = Object.values(dateObj).reduce((sum, val) => {
                return Array.isArray(val) ? sum + val.length : sum;
              }, 0);

              if (colSpan === 0) return null;

              return (
                <th style={{ fontSize: "15px" }} colSpan={colSpan + 1} key={index}>
                  TOTAL: {monthTotals[month] ?? 0}
                </th>
              );
            })}

            {Array.from({ length: 7 }).map((_, i) => (
              <td></td>
            ))} 
          </tr>
        </tbody>
      </table>
    </div>
    </div>

  
    );

}

export default Tsd;